import React, { useLayoutEffect } from "react";
import { AppBar, Box, Tab, Tabs } from "@material-ui/core";
import UserNotification from "../UserNotification";
import DashboardLayout from "layouts/Dashboard";
import GeneralStatus from "./";
import GeneralStatusZoom from "../../../GeneralStatusZoom";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import CustomTabPanel from "../../../../components/CustomTabPanel";
import { useTranslation } from "react-i18next";

function GeneralStatusMain({ location }) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = React.useState(0);
    const [objectivesList, setObjectivesList] = React.useState([]);

    function myCallback(dataFromChild) {
        setObjectivesList(dataFromChild);
    }

    function handleChangeTab(event, newValue) {
        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["tab"] = newValue;
        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
        setActiveTab(newValue);
    }

    useLayoutEffect(() => {
        const parsed = queryString.parse(document.location.search);
        const tab = parsed?.tab ?? 0;
        setActiveTab(Number(tab));
    }, []);

    return (
        <Box>
            <UserNotification />
            <DashboardLayout
                title={t('dashboard-layout.title.general-status')}
                callbackFromParent={myCallback}
                isFirstTime={true}
            >
                <Box style={{ backgroundColor: "white" }}>
                    <AppBar
                        position="static"
                        style={{
                            backgroundColor: "#333333",
                        }}
                    >
                        <Tabs value={activeTab} onChange={handleChangeTab}>
                            <Tab label={t('general-status.tab.general-status-zoom')} />
                        </Tabs>
                    </AppBar>
                    {/*<CustomTabPanel value={activeTab} index={0}>
                        <GeneralStatus params={objectivesList} />
                    </CustomTabPanel>*/}
                    <CustomTabPanel value={activeTab} index={0}>
                        <GeneralStatusZoom />
                    </CustomTabPanel>
                </Box>
            </DashboardLayout>
        </Box>
    );
}

export default withRouter(GeneralStatusMain);
